import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EDIT_BRAND_VOICE_ROUTE = Routes.settings('brand-identity', 'channels');
const SETUP_BRAND_VOICE_ROUTE = Routes.settings('brand-identity');
const BrandVoiceDisabledMessage = ({
  withDataMceHsTooltip,
  linkUse,
  editorSettingsAppUrl
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    "data-mce-hs-tooltip": withDataMceHsTooltip ? 'true' : undefined,
    message: 'TinymcePlugins.hscontentgeneration.brandVoiceDisabledForAppTooltip_jsx',
    elements: {
      Link
    },
    options: {
      // Inpage intercepts all clicks on <a> tags so
      // have to manually open link with window.open for now
      onClick: () => {
        window.open(`${editorSettingsAppUrl}${EDIT_BRAND_VOICE_ROUTE}`, '_blank');
      },
      external: true,
      use: linkUse
    }
  });
};
const BrandVoiceNotSetUpMessage = ({
  withDataMceHsTooltip,
  linkUse,
  editorSettingsAppUrl
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    "data-mce-hs-tooltip": withDataMceHsTooltip ? 'true' : undefined,
    message: "TinymcePlugins.hscontentgeneration.brandVoiceNotSetUpTooltip_jsx",
    elements: {
      Link
    },
    options: {
      // Inpage intercepts all clicks on <a> tags so
      // have to manually open link with window.open for now
      onClick: () => {
        window.open(`${editorSettingsAppUrl}${SETUP_BRAND_VOICE_ROUTE}`, '_blank');
      },
      external: true,
      use: linkUse
    }
  });
};
/**
 * @deprecated - lightweight backwards compatible variant of BrandVoiceMessage tooltip
 * to avoid adding a new dependency on ui-brand-identity-lib for now
 *
 * If you would like to show Brand Identity or Brand Voice info in your app, please reach out to
 * hs-brand-identity-fe and we can talk pros/cons of library component vs. copy/paste
 */
export const BrandVoiceTinyMceMessage = ({
  isSetUp,
  isEnabledForApp,
  withDataMceHsTooltip,
  linkUse,
  editorSettingsAppUrl
}) => {
  const showDisabledMessage = isSetUp && !isEnabledForApp;
  return showDisabledMessage ? /*#__PURE__*/_jsx(BrandVoiceDisabledMessage, {
    withDataMceHsTooltip: withDataMceHsTooltip,
    linkUse: linkUse,
    editorSettingsAppUrl: editorSettingsAppUrl
  }) : /*#__PURE__*/_jsx(BrandVoiceNotSetUpMessage, {
    withDataMceHsTooltip: withDataMceHsTooltip,
    linkUse: linkUse,
    editorSettingsAppUrl: editorSettingsAppUrl
  });
};

/**
 *
 * Editor highlight action label for Brand Voice disabled or needs setup scenarios
 *
 * @deprecated - Lightweight backwards compatible variant of BrandVoiceMessage tooltip
 * to avoid adding a new dependency on ui-brand-identity-lib for now
 *
 * If you would like to show Brand Identity or Brand Voice info in your app, please reach out to
 * hs-brand-identity-fe and we can talk pros/cons of library component vs. copy/paste
 */
export default function BrandVoiceMenuOptionLabel({
  command,
  brandVoiceOptions,
  editorSettingsAppUrl
}) {
  if (command.disabled) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: command.labelKey
      }), /*#__PURE__*/_jsx(HelpIcon, {
        marginInlineStart: "100",
        title: /*#__PURE__*/_jsx(BrandVoiceTinyMceMessage, {
          isSetUp: brandVoiceOptions.isSetUp,
          isEnabledForApp: brandVoiceOptions.isEnabledForApp,
          withDataMceHsTooltip: true,
          linkUse: 'on-dark',
          editorSettingsAppUrl: editorSettingsAppUrl
        }),
        tooltipPlacement: "right"
      })]
    });
  }

  // Enabled version "Apply brand identity" (labelKey copy comes from content-assistance-lib command I18n)
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: command.labelKey
  });
}